import { Button, Result } from 'antd';
import { ROUTES } from '../common/constants';
import useRouter from '../hooks/useRouter';

const ErrorComponent = () => {
  const { navigate, location } = useRouter();
  return (
    <Result
      status="500"
      title="500"
      subTitle="Sorry, something went wrong."
      extra={
        location.pathname !== '/' && (
          <Button type="primary" onClick={() => navigate(ROUTES.MAIN)}>
            Back Home
          </Button>
        )
      }
    />
  );
};

export default ErrorComponent;
